/**
 * Custom Modal Handler
 * Requires jQuery
 */

class CustomModal {
  constructor(modalId) {
    this.modalId = modalId;
    const idSel =
      typeof $ !== "undefined" && typeof $.escapeSelector === "function"
        ? "#" + $.escapeSelector(modalId)
        : "#" + modalId;
    this.modal = $(idSel);
    // Keep modal at document root so fixed positioning is viewport-based,
    // not clipped by transformed/overflow ancestors (e.g. cart drawer panel).
    if (this.modal.length && !this.modal.parent().is("body")) {
      this.modal.appendTo("body");
    }
    this.overlay = this.modal.find(".custom-modal__overlay");
    this.closeBtn = this.modal.find(".custom-modal__close");
    this.trigger = $(`.modal-trigger[data-modal-trigger="${modalId}"]`);
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    // Trigger component click
    if (this.trigger.length) {
      this.trigger.on("click", () => this.open());
    }

    // Close button click
    this.closeBtn.on("click", () => this.close());

    // Close on overlay click
    this.overlay.on("click", () => this.close());

    // Prevent closing when clicking modal content
    this.modal.find(".custom-modal__container").on("click", (e) => {
      e.stopPropagation();
    });

    // Close on ESC — namespaced so re-init after Section Rendering does not stack handlers
    $(document)
      .off(`keydown.customModal-${this.modalId}`)
      .on(`keydown.customModal-${this.modalId}`, (e) => {
        if (e.key === "Escape" && this.isOpen) {
          this.close();
        }
      });
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.modal.addClass("is-active");
    $("body").css("overflow", "hidden"); // Prevent background scrolling

    // Trigger custom event
    this.modal.trigger("modal:opened");
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.modal.removeClass("is-active");
    $("body").css("overflow", "");

    // Trigger custom event
    this.modal.trigger("modal:closed");
  }

  setContent(content) {
    this.modal.find(".custom-modal__content").html(content);
  }

  setTitle(title) {
    this.modal.find(".custom-modal__title").text(title);
  }
}

/** @param {JQuery|Element|Document|null|undefined} scope Root to search under; null/undefined = whole document */
function registerCustomModalsIn(scope) {
  window.customModals = window.customModals || {};
  let $scope;
  if (scope == null) {
    $scope = $(document);
  } else if (scope.jquery) {
    $scope = scope.length ? scope : $(document);
  } else {
    $scope = $(scope);
  }
  if (!$scope.length) return;
  $scope.find(".custom-modal").each(function () {
    if (this.dataset && this.dataset.customModalBound === "1") return;
    const modalId = $(this).attr("id");
    if (modalId) {
      window.customModals[modalId] = new CustomModal(modalId);
      if (this.dataset) this.dataset.customModalBound = "1";
    }
  });
}

window.registerCustomModalsIn = registerCustomModalsIn;

/** Event name: dispatch after any HTML swap that may contain `.custom-modal` (cart AJAX, etc.). */
const MODALS_REBIND_EVENT = "theme:modals-rebind";

/**
 * Prefer this over calling `registerCustomModalsIn` from many files.
 * `root`: Element to scan (e.g. `#cart-template`, `#cart-drawer`); omit to re-scan entire document.
 */
function dispatchModalRebind(root) {
  document.dispatchEvent(
    new CustomEvent(MODALS_REBIND_EVENT, {
      bubbles: true,
      detail: { root: root == null ? document : root },
    })
  );
}

window.dispatchModalRebind = dispatchModalRebind;

function attachModalRebindListeners() {
  document.addEventListener(MODALS_REBIND_EVENT, function (e) {
    const root = e.detail && e.detail.root;
    registerCustomModalsIn(root == null ? document : root);
  });

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    const sectionEl = document.getElementById(
      "shopify-section-" + e.detail.sectionId
    );
    if (sectionEl) {
      registerCustomModalsIn(sectionEl);
    }
  });
}

function observeModalDomChanges() {
  if (typeof MutationObserver === "undefined") return;
  const observer = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      if (!m.addedNodes || !m.addedNodes.length) continue;
      for (let j = 0; j < m.addedNodes.length; j++) {
        const node = m.addedNodes[j];
        if (!(node instanceof Element)) continue;
        if (node.matches && node.matches(".custom-modal")) {
          registerCustomModalsIn(node.parentElement || node);
          continue;
        }
        if (node.querySelector && node.querySelector(".custom-modal")) {
          registerCustomModalsIn(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Initialize modals when DOM is ready
$(document).ready(function () {
  window.customModals = {};
  registerCustomModalsIn(document);
  attachModalRebindListeners();
  observeModalDomChanges();
});

// Example usage:
/*
  // Create modal in liquid template
  {% render 'modal', 
    id: 'my-modal',
    title: 'My Modal Title',
    content: 'My modal content',
    width: 600,
    component: '<button class="btn">Open Modal</button>'
  %}

  // Or with custom component
  {% render 'modal',
    id: 'image-modal',
    title: 'Image Preview',
    content: '<img src="large-image.jpg">',
    component: '<img src="thumbnail.jpg" class="thumbnail">'
  %}

  // Or with another snippet as trigger
  {% render 'modal',
    id: 'product-modal',
    title: 'Quick View',
    content: product-details,
    component: {% render 'product-card', product: product %}
  %}

  // You can still open/close programmatically
  customModals['my-modal'].open();
  customModals['my-modal'].close();

  // Update content dynamically
  customModals['my-modal'].setContent('New content');

  // Update title dynamically
  customModals['my-modal'].setTitle('New title');

  // Listen for modal events
  $('#my-modal').on('modal:opened', function() {
    console.log('Modal opened');
  });

  $('#my-modal').on('modal:closed', function() {
    console.log('Modal closed');
  });
*/
